<template>
    <div style="display:inline;">
        <ToolButton v-if="!Editor.isActive('link')" :Editor="Editor" KnownIcon="Link"
            @ToolClick="Editor.chain().focus().extendMarkRange('link').setLink({ href: '' }).run()">
        </ToolButton>
        <ToolButton v-if="Editor.isActive('link')" :Editor="Editor" KnownIcon="LinkUnlink"
            @ToolClick="Editor.chain().focus().unsetLink().run()" :class="{ 'toggled': Editor.isActive('link') }">
        </ToolButton>
    </div>
</template>
<script>

import ToolButton from '@/views/components/atoms/tiptap/Predefined/Buttons/ToolButton.vue';

export default ({
    components: {
        ToolButton
    },
    props: ["Editor"]
});
</script>